import React, { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import CS from "../../../services/commonService";
import { useFormik } from "formik";
import { usechangePassword } from "../../../queryHooks/useProfile";
import { changePasswordSchema } from "../../../validations/profileValidations";
import { useStore } from "../../../zustand/store";

//	Component starts
const ChangePassword = ({ onCloseModal }) => {
	const setLoading = useStore((state) => state.setLoading);
	//Defining state object for formik
	const [formData] = useState({
		oldPassword: "",
		newPassword: "",
		confirmPassword: "",
	});

	const [hideoldPassword, setHideoldPassword] = useState(true);
	const [hideNewPassword, setHideNewPassword] = useState(true);
	const [hideConfirmPassword, setHideConfirmPassword] = useState(true);

	const { values, errors, handleChange, handleSubmit, touched, handleBlur } =
		useFormik({
			initialValues: formData,
			validationSchema: changePasswordSchema,
			validateOnChange: true,
			onSubmit: (value) => {
				setLoading(true);
				changePassword({
					old_password: value.oldPassword,
					new_password: value.newPassword,
				});
			},
		});

	const {
		mutateAsync: changePassword,
		error: errorChangePassword,
		data: dataChangePassword,
	} = usechangePassword();

	useEffect(() => {
		if (dataChangePassword) {
			if (dataChangePassword.status === "success") {
				CS.showSuccessMessage(dataChangePassword.message);
				onCloseModal();
				setLoading(false);
			} else if (dataChangePassword.status === "fail") {
				CS.showErrorMessage(dataChangePassword.message);
			}
		}
	}, [dataChangePassword]);

	useEffect(() => {
		if (errorChangePassword) {
			setLoading(false);
			CS.showErrorMessage(errorChangePassword.response?.data?.message);
		}
	}, [errorChangePassword]);

	/******************************************************************************************
    @Purpose    :   To show the tooltip for current password show/hid
    *******************************************************************************************/
	const renderToolTipForoldPassword = () =>
		hideoldPassword ? "Show Password" : "Hide Password";
	/******************************************************************************************
    @Purpose    :   To show the tooltip for new password show/hid
    *******************************************************************************************/
	const renderTooltipForNewPassword = () =>
		hideNewPassword ? "Show Password" : "Hide Password";
	/******************************************************************************************
    @Purpose    :   To show the tooltip for confirm password show/hid
    *******************************************************************************************/
	const renderTooltipForConfirmPassword = () =>
		hideoldPassword ? "Show Password" : "Hide Password";

	return (
		<div className="modal-content">
			<div className="modal-header">
				<h5 className="modal-title">Change Password</h5>
			</div>
			<div className="notification-form modal-body password-modal">
				<div className="row">
					<div className="col-md-12">
						<form onSubmit={(e) => handleSubmit(e)}>
							<div className="mb-3">
								<div className="form-group mb-0">
									<label className="label xl-label">Current Password</label>
									<div className="w-100 position-relative">
										<input
											className="form-control"
											type={hideoldPassword ? "password" : "text"}
											placeholder=" Enter Current Password"
											name="oldPassword"
											id="oldPassword"
											value={values.oldPassword}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<span
											onClick={() => setHideoldPassword(!hideoldPassword)}
											data-tip
											data-for="oldPassword"
											className={
												hideoldPassword
													? "bx bx-hide field-icon-profile toggle-password"
													: "bx bx-show field-icon-profile toggle-password"
											}
										></span>
										<ReactTooltip id="oldPassword" place="top" effect="solid">
											{renderToolTipForoldPassword()}
										</ReactTooltip>
									</div>
								</div>
								<div className="error-message-password">
									<span className="text-danger error-msg d-block mb-2">
										{errors.oldPassword && touched.oldPassword
											? errors.oldPassword
											: null}
									</span>
								</div>
							</div>
							<div className="mb-md-4 mb-3">
								<div className="form-group mb-0">
									<label className="label xl-label">New Password</label>
									<div className="w-100 position-relative">
										<input
											className="form-control"
											type={hideNewPassword ? "password" : "text"}
											placeholder="Enter New Password"
											id="newPassword"
											name="newPassword"
											value={values.newPassword}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<span
											onClick={() => setHideNewPassword(!hideNewPassword)}
											data-tip
											data-for="newPassword"
											className={
												hideNewPassword
													? "bx bx-hide field-icon-profile toggle-password"
													: "bx bx-show field-icon-profile toggle-password"
											}
										></span>
										<ReactTooltip id="newPassword" place="top" effect="solid">
											{renderTooltipForNewPassword()}
										</ReactTooltip>
										<em className="fa fa-lock" aria-hidden="true" />
									</div>
								</div>
								<div className="error-message-password">
									<span className="text-danger error-msg d-block mb-2">
										{errors.newPassword && touched.newPassword
											? errors.newPassword
											: null}
									</span>
								</div>
								<div className="form-group mb-0">
									<label className="label xl-label">Confirm Password</label>
									<div className="w-100 position-relative">
										<input
											className="form-control"
											type={hideConfirmPassword ? "password" : "text"}
											placeholder=" Enter Confirm Password"
											id="confirmPassword"
											name="confirmPassword"
											value={values.confirmPassword}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<span
											onClick={() =>
												setHideConfirmPassword(!hideConfirmPassword)
											}
											data-tip
											data-for="confirmPassword"
											className={
												hideConfirmPassword
													? "bx bx-hide field-icon-profile toggle-password"
													: "bx bx-show field-icon-profile toggle-password"
											}
										></span>
										<ReactTooltip
											id="confirmPassword"
											place="top"
											effect="solid"
										>
											{renderTooltipForConfirmPassword()}
										</ReactTooltip>
										<em className="fa fa-lock" aria-hidden="true" />
									</div>
								</div>
								<div className="error-message-password">
									<span className="text-danger error-msg d-block mb-2">
										{errors.confirmPassword && touched.confirmPassword
											? errors.confirmPassword
											: null}
									</span>
								</div>
							</div>
							<div className="mt-5 text-right">
								<button className="btn btn-primary" type="submit">
									Update
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ChangePassword;
